export default __webpack_public_path__ + "static/media/atpar2.07e3d8b3.png";